import { render, staticRenderFns } from "./componentPannel.vue?vue&type=template&id=acdb8534&scoped=true"
import script from "./componentPannel.vue?vue&type=script&lang=js"
export * from "./componentPannel.vue?vue&type=script&lang=js"
import style0 from "./componentPannel.vue?vue&type=style&index=0&id=acdb8534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acdb8534",
  null
  
)

export default component.exports